import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 40px 40px 40px 47px;
  height: calc(100% - 92px);
  overflow: auto;
`;
